import { Button, Icon, type MaterialSymbol } from "@qw/ui";
import type { FC, ReactNode } from "react";

import { getResourceLinkHandler } from "../../chat.helpers";
import type { McpResourceLink } from "../../chat.types";
import { useChat } from "../../providers/chat-provider";

export const ArtifactRowButton: FC<{
  children: ReactNode;
  icon?: MaterialSymbol;
  resource: McpResourceLink;
}> = ({ children, icon, resource }) => {
  const { resourceLinkHandlers } = useChat();
  const handler = getResourceLinkHandler(resource, resourceLinkHandlers);

  return (
    <Button
      type="button"
      variant="ghost"
      disabled={!handler}
      onClick={() => void handler?.onClick(resource)}
      className="h-auto w-full justify-start gap-2 whitespace-normal px-3 py-2 text-left font-normal"
    >
      <Icon icon={icon ?? handler?.icon ?? "open_in_new"} className="mx-0! shrink-0 text-base!" />
      {children}
    </Button>
  );
};
